import React from "react";
import "./GameRulesCard.css";

interface GameRulesCardProps {
  logo: string;
  gameName: string;
  rules: string[];       // un tableau de règles
  onNext: () => void;
  loading?: boolean;
  buttonText?: string;
}

export default function GameRulesCard({
  logo,
  gameName,
  rules,
  onNext,
  loading = false,
  buttonText = "Suivant",
}: GameRulesCardProps) {
  return (
    <div className="rules-card">
      {/* Logo + titre */}
      <div className="rules-header">
        <img src={logo} alt="logo" className="rules-logo" />
        <h2 className="rules-title">{gameName}</h2>
      </div>

      {/* Bloc unique des règles */}
      <div className="rules-box">
        {rules.map((r, i) => (
          <p key={i} className="rules-text">
            {r}
          </p>
        ))}
      </div>

      {/* Bouton Suivant */}
      <button
        className="fullWidth rules-button"
        onClick={onNext}
        disabled={loading}
      >
        {loading ? "Chargement…" : buttonText}
      </button>
    </div>
  );
}
